export default __webpack_public_path__ + "static/media/SDGs.fccba963.svg";